function abc(){
    alert('check');
}

export{abc}